import { OrgSdk } from 'lib-klab-sdks';
import { Holiday, HolidayScope, HolidayStatus } from '../../../domain/models/organization/holiday.model';

export function mapSDKHolidayToDomain(sdk: OrgSdk.HolidayResponse): Holiday {
    return {
        id: sdk.holidayId ?? 0,
        date: String(sdk.date ?? ''),
        name: sdk.name ?? '',
        countryCode: sdk.countryCode ?? undefined,
        scope: (sdk.scope as HolidayScope) ?? 'NATIONAL',
        locationId: sdk.locationId ?? null,
        status: (String(sdk.status ?? 'ACTIVE') as HolidayStatus),
    };
}
